export interface DownloadRelease {
  platform: string;
  version: string;
  fileLabel: string;
  url: string;
}

// Add verified installer URLs here when a build is ready for distribution.
export const releases: DownloadRelease[] = [];
